import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { DiscoveryStep } from "~/components/ui/discovery-step";
import { FormField } from "~/components/ui/form-field";
import { ControlledRadioGroup } from "~/components/form/controlled-inputs";

import {
  DefineUrgencyAndReadinessSchema,
  startTimeField,
  supportField,
  urgencyAndReadinessStep,
} from "~/lib/schemas/coach-discovery";

import type { DefineUrgencyAndReadinessForm } from "~/lib/schemas/coach-discovery";
import { useDiscoveryForm } from "~/lib/hooks/use-discovery-form";
import { createNoIndexMeta } from "~/lib/shared/meta";

export const Route = createFileRoute("/_public/discovery/steps/2/")({
  head: () =>
    createNoIndexMeta(
      "Step 2: Urgency & Readiness – Dream Coach Match",
      "Define your urgency and readiness for coaching in our discovery process",
    ),
  component: DefineUrgencyAndReadinessStep,
});

function DefineUrgencyAndReadinessStep() {
  const { form, handleNextStep, handlePreviousStep } = useDiscoveryForm(
    DefineUrgencyAndReadinessSchema,
    2,
  );

  const { handleSubmit, control, formState } = form;
  const { errors, isSubmitting, isValid } = formState;

  const onSubmit = (_data: DefineUrgencyAndReadinessForm) => {
    handleNextStep();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <DiscoveryStep.Title title={urgencyAndReadinessStep.title} />
      <DiscoveryStep.Card>
        <FormField
          labelSize="xl"
          error={errors.startTime?.message}
          label={startTimeField.subTitle || ""}
        >
          <ControlledRadioGroup
            control={control}
            name="startTime"
            options={
              startTimeField.options?.map(({ value, label }) => ({
                value,
                label,
              })) || []
            }
            className="flex flex-col gap-y-4"
          />
        </FormField>
      </DiscoveryStep.Card>
      <DiscoveryStep.Card>
        <FormField
          labelSize="xl"
          error={errors.support?.message}
          label={supportField.subTitle || ""}
        >
          <ControlledRadioGroup
            control={control}
            name="support"
            options={
              supportField.options?.map(({ value, label, description }) => ({
                value,
                label,
                description,
              })) || []
            }
            className="flex flex-col gap-y-4"
          />
        </FormField>
      </DiscoveryStep.Card>
      <DiscoveryStep.Control
        prev={handlePreviousStep}
        type="submit"
        disabled={!isValid}
        loading={isSubmitting}
      />
    </form>
  );
}
